<template>
  <UiModal
    :show="showAmount"
    title="领取奖励"
    iconType="gift_1"
    size="lg"
    @close="close"
  >
  <div class="task">
    <ul class="task-box">
      <li class="item" v-for="(value, index) in listData" :key="index">
        <div class="item-left">
          <div class="item-icon" >
            <div class="icon" :style="{'background-image': `url(${value.imgUrl})`}"></div>
            <UiLabel class="tip" shadow-color="#6D0402">{{ value.coins }}</UiLabel>
          </div>
          <div class="title">
            {{ value.title }}
          </div>
        </div>

        <div class="item-right">
          <span class="time-target">
            ({{ value.progress }}/{{ value.progressTotal }})
          </span>
          <button
            class="button-status"
            :class="classMode[value.status]"
            @click="handleStatusClick(value.status, value, index)"
          >
            <UiLabel>{{ statusMode[value.status] }}</UiLabel>
          </button>
        </div>
        <!-- {{ value }} -->
      </li>
    </ul>
  </div>


  </UiModal>
</template>

<script setup>
import { ref, computed, getCurrentInstance } from 'vue'
import * as api from '@/service/index'
import { useAppStore } from '@/store'
import { useModal } from '@/composables/useModal'
import { usePrompt } from '@/composables/usePrompt'
import UiModal from '@/components/ui-modal.vue'
import UiLabel from '@/components/ui-label.vue'

const { proxy } = getCurrentInstance()
const appStore = useAppStore()

const classMode = ref(['undone', 'receive', 'received'])
const statusMode = ref(['未完成', '领取', '已领取'])
const showAmount = ref(false)
const inRequest = ref(false)
const listData = ref([])
const padlock = ref(false)

const token = computed(() => appStore.token)
const amount = computed(() => appStore.amount)

// 模板 ref
const { showPrompt } = usePrompt()

const { close } = useModal('daily-tasks', showAmount, {
  onOpen() {
    fetchActivityList()
    if (typeof tapdb === 'undefined') return
    tapdb.trackEvent('点击领取奖励')
  }
})

function handleStatusClick(status, value,index) {
  if(!padlock.value){
    padlock.value = true
    if (status === 1) {
      listData.value[index].status = 2
    }
    statusClick(status, value)
    padlock.value = false
  }

}
// 每日任务
async function fetchActivityList() {
  try {
    if(!token.value) return;
    const res = await api.getTaskList(token.value)
    // console.log('res', res)
    // console.log('res', res)
    if (res.status === 200) {
      // console.log('ressss', res)
      const { dailyTasks } = res.data
      listData.value = dailyTasks

    }
  } catch (err) {
    console.log(err)
  }
}

async function statusClick(status,value) {
  if (classMode.value[status] === 'receive' && !inRequest.value) {
    inRequest.value = true
      let data = {
         taskId: value.id
      }
      if(!token.value) return;
      let response = await api.getActivityReward(token.value, data)
      // console.log('response', response)
      if (response.status === 200 && response.data === true) {

        fetchActivityList()
        appStore.reqRedDotState()
        const  now = await api.reqcurrentTime()
        if(value.isSend){
          if(!token.value) return;
          const res= await api.reqGiftList({token: token.value,force : true})
          if(res.status === 200){
            res.data?.find(item => {
              if(typeof tapdb === 'undefined') return;
              if(item.giftId === 'xc006'){
                if(now.status === 200){
                  const countdown = proxy.formatDay(now.data)
                  // 领取任务奖励
                  // console.log(value.id +"+"+countdown)
                    tapdb.trackEvent("领取奖励", {
                    '#mission_unique_id': value.id +"+"+countdown,
                     // 获得道具余量
                    '#prop_after': item.count,
                      // 获得物品数量
                     '#item_gain': +value.coins,
                       // 物品id
                      '#prop_id': item.giftId,
                       // 道具获得的原因
                      '#prop_type':value.title,
                    });
                }


              }
            })
          }

        }else{
          appStore.reqUserInfo(true)
          if(now.status === 200){
            if(typeof tapdb === 'undefined') return;
            const countdown = proxy.formatDay(now.data)
            // 领取任务奖励 货币
            // 埋点描述
              tapdb.trackEvent("领取奖励", {
                // 埋点行为，领取任务
              '#mission_unique_id': value.id +"+"+countdown,
              // 本次货币变化
              '#value_change': +value.coins,
              // 变化余量
              '#value_after': +amount.value.quizRemainNum,
              // 任务id
              '#coin_id': value.id,
              // 任务描述
              '#via_type':value.desc,
            });
          }
        }
        inRequest.value = false
        showPrompt('领取成功～')
      } else {
        showPrompt(response.data)
      }
  }
}

</script>

<style lang="scss" scoped>
.task {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 94px 24px 36px 38px;
}

.task-box {
	// flex: 1;
	font-size: 20px;
	height: 100%;
	padding-right: 19px;
	overflow: hidden scroll;

	.item {
		display: flex;
		justify-content: space-between;
		align-items: center;
    width: 1009px;
		height: 98px;
		margin-bottom: 16px;
    background-image: url(https://website.xdcdn.net/poster/58881/26match/common/Q05Xw0u1.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 100% 100%;
    filter: drop-shadow(0 4px 4px rgba(#000, 0.2));

		.item-left {
			display: flex;
			align-items: center;
			margin-left: 20px;

			.item-icon {
				width: 78px;
				height: 78px;
				position: relative;
				background-image: url(https://website.xdcdn.net/poster/58881/26match/common/QQikoyc2.png);
				background-position: center;
				background-repeat: no-repeat;
				background-size: contain;
				border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
				@include boxShadowSet_Btn();

				.icon {
          position: relative;
					width: 45px;
					height: 44px;
					// background-image: url('https://website.xdcdn.net/module/sausage-match/images/quiz/coin.png');
					background-repeat: no-repeat;
					background-position: center;
					background-size: contain;
				}

				.tip {
					position: absolute;
					font-size: 16px;
					right: 6px;
					bottom: 6px;
					font-weight: bold;

					// UiLabel 内部 span, scoped 需 :deep 穿透
					:deep(.label-shadow) {
						-webkit-text-stroke: 0.3em;
					}
				}
			}

			.title {
				// width: get_vh(280);
				margin-left: 20px;
				color: #6D0402;
			}
		}

		.item-right {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 0 28px;

			.time-target {
				display: inline-block;
				width: 114px;
				text-align: right;
        color: #6D0402;
			}

			.button-status {
				position: relative;
				width: 92px;
				height: 44px;
				font-size: 20px;
				margin-left: 12px;
				font-weight: bold;
				box-sizing: border-box;

				// label-text 走 UiLabel 默认白色, 无需覆盖
				.label-box {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 100%;
					height: 100%;
				}

				&.undone {           // status=0 未完成
					background: url(https://website.xdcdn.net/poster/58881/26match/common/QQhbgwtp.png) center/contain no-repeat;
					--label-shadow-color: rgba(0, 0, 0, 0.4);
				}
				&.receive {          // status=1 可领取
					background: url(https://website.xdcdn.net/poster/58881/26match/common/QQhazoyh.png) center/contain no-repeat;
					--label-shadow-color: #423824;
				}
				&.received {         // status=2 已领取
					background: url(https://website.xdcdn.net/poster/58881/26match/common/QQhc0tu7.png) center/contain no-repeat;
					--label-shadow-color: rgba(0, 0, 0, 0.4);

					&::before {
						content: '';
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						width: 86px;
						height: 38px;
						background: rgba(0, 0, 0, 0.2);
						z-index: 1;
					}
				}
			}
		}
	}
}
</style>
